import {
  ElAffix,
  ElButton,
  ElCol,
  ElCollapseTransition,
  ElLoading,
  ElRow,
} from 'element-plus';

export const components = [
  ElAffix,
  ElButton,
  ElCol,
  ElCollapseTransition,
  ElRow,
];

export const plugins = [ElLoading];
